var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:('aspect-ratio:' + _vm.calcWidth + '/' + _vm.calcHeight),attrs:{"src":_vm.src,"width":_vm.width,"alt":_vm.alt,"srcset":_vm.set}})}
var staticRenderFns = []

export { render, staticRenderFns }